import * as React from 'react';

var CircleChevronGray = function (_a) {
    var className = _a.className;
    return (React.createElement("svg", { className: className, fill: "none", height: "40", viewBox: "0 0 40 40", width: "40", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M20 0C8.95161 0 0 8.95161 0 20C0 31.0484 8.95161 40 20 40C31.0484 40 40 31.0484 40 20C40 8.95161 31.0484 0 20 0ZM10.8145 18.629L21.7419 7.70161C22.5 6.94355 23.7258 6.94355 24.4758 7.70161L25.8468 9.07258C26.6048 9.83065 26.6048 11.0565 25.8468 11.8065L17.6532 20L25.8468 28.1935C26.6048 28.9516 26.6048 30.1774 25.8468 30.9274L24.4758 32.2984C23.7177 33.0565 22.4919 33.0565 21.7419 32.2984L10.8145 21.371C10.0565 20.6129 10.0565 19.3871 10.8145 18.629Z", fill: "#161616" })));
};

export { CircleChevronGray as default };
//# sourceMappingURL=CircleChevronGray.esm.js.map
